import { Injectable, Type } from '@angular/core';
import {
  InternalPluginModuleConfig,
  InternalPluginModuleConfigExpose,
  ModuleProxy,
} from '@osos/shared/types';

@Injectable()
export class DynamicComponentFactoryService {
  private readonly _internalRegistry = new Map<
    string,
    InternalPluginModuleConfigExpose
  >();
  private readonly _moduleProxyMap = new Map<string, ModuleProxy>();

  registerInternalPlugin(config: InternalPluginModuleConfig): void {
    // Register the exposed components:
    config.exposes.forEach((expose) => {
      this._internalRegistry.set(expose.name, expose);
    });
  }

  // TODO: Use the dynamic-component interface instead of unknown;
  /**
   * Load the desired dynamic component using its full-name.
   * @param name The component full name.
   */
  async loadComponent(name: string): Promise<Type<unknown>> {
    // Load from memory if the component is already loaded:
    if (this._moduleProxyMap.has(name)) {
      return this._moduleProxyMap.get(name).component;
    }

    // TODO: check if it's remote or internal plugin (For remote: loadRemoteModule by pluginName and componentName).
    // For remote plugin's metadata: We should compute the `componentFullName` from `PLUGIN_NAME:COMPONENT_NAME` and store it in each metadata.
    // The `componentFullName` will be used as an ID for the desired dynamic component.
    // The metadata's `componentName` will be used here only in this factory to load the remote module.

    // Load from internal registry:
    if (this._internalRegistry.has(name)) {
      const componentEntry = this._internalRegistry.get(name);
      if (componentEntry.loadModuleProxy) {
        try {
          const result = await componentEntry.loadModuleProxy();

          if (!result) {
            return null;
          }

          if (!result.default) {
            return null;
          }

          const moduleProxy = result.default;

          if (!moduleProxy.component) {
            return null;
          }

          // Store in memory to avoid calling the import each time the component requested:
          this._moduleProxyMap.set(name, moduleProxy);

          return moduleProxy.component;
        } catch (err) {
          return null;
        }
      } else {
      }
    }

    // TODO: Return component-not-found placeholder instead of null if the component couldn't be loaded:
    return null;
  }
}
